/* ============================================================
   Skeleton — lightweight shimmer placeholders.

   Used by QueryShell + route-level Suspense fallbacks so the
   shell renders instantly (dark bg + skeleton rectangles) and
   content fills in when the query resolves, rather than showing
   a static "Loading…" text.
   ============================================================ */

export function Skeleton({
  w = '100%',
  h = 16,
  r = 6,
  className,
  style,
}: {
  w?: string | number;
  h?: string | number;
  r?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={`sk-box ${className ?? ''}`}
      style={{
        width: w,
        height: h,
        borderRadius: r,
        ...style,
      }}
    />
  );
}

/** Full-page skeleton used as a route-level Suspense fallback.
 *  Mimics the ForYou vertical card stack so the first paint is
 *  never a blank screen. */
export function FeedSkeleton() {
  return (
    <div className="app-page fy-stage">
      <div className="fy-device">
        <header className="fy-hero">
          <div className="fy-hero-row">
            <Skeleton w={140} h={22} r={4} />
            <Skeleton w={80} h={14} r={4} />
          </div>
          <div className="fy-topbar" style={{ display: 'flex', gap: 12 }}>
            <Skeleton w={72} h={18} r={9} />
            <Skeleton w={84} h={18} r={9} />
            <Skeleton w={60} h={18} r={9} />
          </div>
        </header>
        <div className="fy-feed">
          <div className="fy-slide fy-slide--skeleton">
            <div className="sk-card">
              <Skeleton w={120} h={14} />
              <Skeleton w="65%" h={34} r={8} style={{ marginTop: 18 }} />
              <Skeleton w="50%" h={18} style={{ marginTop: 10 }} />
              <Skeleton w="100%" h={8} r={4} style={{ marginTop: 22 }} />
              <Skeleton w="100%" h={8} r={4} style={{ marginTop: 6 }} />
              <Skeleton w="80%" h={8} r={4} style={{ marginTop: 6 }} />
              <Skeleton w="90%" h={28} r={6} style={{ marginTop: 22 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/** Generic one-page skeleton for sub-routes (match detail, team, player). */
export function PageSkeleton() {
  return (
    <div className="app-page">
      <div className="sk-page">
        <Skeleton w="40%" h={14} />
        <Skeleton w="85%" h={32} r={8} style={{ marginTop: 14 }} />
        <Skeleton w="60%" h={18} style={{ marginTop: 10 }} />
        <Skeleton w="100%" h={140} r={12} style={{ marginTop: 22 }} />
        <Skeleton w="100%" h={80} r={10} style={{ marginTop: 14 }} />
        <Skeleton w="100%" h={80} r={10} style={{ marginTop: 10 }} />
      </div>
    </div>
  );
}
